import React from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import './SegmentedCapacityBar.scss';

const { block, element } = bem('segmented-capacity-bar');

export const SEGMENTED_CAPACITY_BAR_SEGMENT = {
  CLASSPASS: 'classpass',
  DIRECT: 'direct',
  UNFILLED: 'unfilled',
};

const FILL_BAR_EMPTY_VALUE = 0;
const FILL_BAR_FULL_PERCENT = 100;

function getVisibleSegments(segments) {
  return segments.filter(({ value }) => value > FILL_BAR_EMPTY_VALUE);
}

function getTrackTotal(segments) {
  return segments.reduce((sum, { value }) => sum + value, FILL_BAR_EMPTY_VALUE);
}

const SegmentedCapacityBar = ({ className, legendItems = [], muted = false, segments = [] }) => {
  const visibleSegments = getVisibleSegments(segments);
  const trackTotal = getTrackTotal(visibleSegments);
  const renderedSegments =
    trackTotal > FILL_BAR_EMPTY_VALUE
      ? visibleSegments
      : [{ key: SEGMENTED_CAPACITY_BAR_SEGMENT.UNFILLED, value: FILL_BAR_FULL_PERCENT }];

  return (
    <div className={block({ muted }, className)}>
      <div className={element('track')}>
        {renderedSegments.map(({ key, value }) => (
          <span className={element('segment', { [key]: true })} key={key} style={{ flexGrow: value }} />
        ))}
      </div>
      {legendItems.length > 0 ? (
        <div className={element('legend')}>
          {legendItems.map(({ accessory, key, label }) => (
            <span className={element('legend-item')} key={key}>
              <span className={element('swatch', { [key]: true })} />
              <span className={element('legend-label')}>{label}</span>
              {accessory}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};

SegmentedCapacityBar.propTypes = {
  className: PropTypes.string,
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      accessory: PropTypes.node,
      key: PropTypes.oneOf(Object.values(SEGMENTED_CAPACITY_BAR_SEGMENT)).isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  muted: PropTypes.bool,
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOf(Object.values(SEGMENTED_CAPACITY_BAR_SEGMENT)).isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
};

export default SegmentedCapacityBar;
